import api from './index.js';

api.internals.register(api.tag.TagSelector.TAG_PRESSABLE, api.core.Toggle);

export default api;
